import React, { useEffect } from 'react';
import MovieSchedule from './components/MovieSchedule';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './styles/App.css';
import './assets/fonts/bogueslab-semibold.otf';

import logo from './assets/eventspire.png';
import posthog from 'posthog-js';

const App = () => {
    useEffect(() => {
        document.title = "eventspire";

        // --- Set or get tracking_id cookie ---
        let trackingId = document.cookie
            .split('; ')
            .find(row => row.startsWith('tracking_id='))
            ?.split('=')[1];

        if (!trackingId) {
            trackingId = crypto.randomUUID();
            const expires = new Date(Date.now() + 365 * 864e5).toUTCString(); // 1 year
            document.cookie = `tracking_id=${trackingId}; expires=${expires}; path=/; SameSite=Lax`;

            // Optional: send to backend
            fetch('/api/track-user', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tracking_id: trackingId }),
            });
        }

        // --- PostHog Identify ---
        if (trackingId) {
            posthog.identify(trackingId);
        }
    }, []);

    return (
        <Router>
            <div className="App">
                <header className="app-header">
                    <div className="app-header-inner">
                        <Link to="/">
                            <img src={logo} alt="Eventspire Logo" className="app-logo" />
                        </Link>
                    </div>
                </header>

                <Routes>
                    <Route path="/" element={<MovieSchedule />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;